export function defaultZ(d) {
  return d[2];
}
export default function (_) {
  return arguments.length ? (this._z = _, this) : this._z;
}